export const REVIEW_CYCLES_ELIGIBLE_EMPLOYEES = 'REVIEW_CYCLES_ELIGIBLE_EMPLOYEES'
export const REVIEW_CYCLES_ELIGIBLE_EMPLOYEES_PENDING = 'REVIEW_CYCLES_ELIGIBLE_EMPLOYEES_PENDING'
export const REVIEW_CYCLES_ELIGIBLE_EMPLOYEES_FULFILLED =
  'REVIEW_CYCLES_ELIGIBLE_EMPLOYEES_FULFILLED'
export const REVIEW_CYCLES_ELIGIBLE_EMPLOYEES_REJECTED = 'REVIEW_CYCLES_ELIGIBLE_EMPLOYEES_REJECTED'

export const RESET_REVIEW_CYCLES_ELIGIBLE_EMPLOYEES = 'RESET_REVIEW_CYCLES_ELIGIBLE_EMPLOYEES'
